<template>
    <div>
        <h1 class="subtitle">Centros de Costo</h1>
        <hr />
        <div class="columns">
            <div class="column is-9">
                <button class="button is-success" @click="showBox = true">
                    <b-icon icon="plus" size="is-small"></b-icon> <span>Agregar</span>
                </button>
            </div>
            <div class="column is-3">
                <input type="text" class="input is-pulled-right" @keyup="searchData" placeholder="Buscar" v-model="search" />
            </div>
        </div>
        <b-table :data="data" :loading="loading" paginated backend-pagination bordered :total="total" :per-page="perPage" aria-next-label="Siguiente" aria-previous-label="Anterior" aria-page-label="Pág." aria-current-label="Pág. actual" @page-change="onPageChange">
            <template slot-scope="props">
                <b-table-column field="codigo" label="Código" header-class="is-info">
                    {{ props.row.codigo }}
                </b-table-column>
                <b-table-column field="descripcion" label="Descripción" header-class="is-info">
                    {{ props.row.descripcion }}
                </b-table-column>
                <b-table-column field="es_activo" label="Activo" header-class="is-info">
                    <b-icon title="Activo" v-if="props.row.es_activo" icon="check-circle-outline" type="is-success"></b-icon>
                    <b-icon title="Inactivo" v-else icon="close-circle" type="is-danger"></b-icon>
                </b-table-column>
                <b-table-column label="" header-class="is-info">
                    <a href="#" @click.prevent="loadEditCentroCosto(props.row)" title="Modificar">
                        <b-icon icon="pencil" type="is-info"></b-icon>
                    </a>
                    <a href="#" @click.prevent="deleteRow(props.row)" title="Eliminar"><span class="icon has-text-danger">
                            <i class="mdi mdi-delete mdi-18px"></i>
                        </span>
                    </a>
                </b-table-column>
            </template>
            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>No se encontraron Centros de Costo</p>
                    </div>
                </section>
            </template>
        </b-table>
        <b-modal :active.sync="showBox" :on-cancel="cleanAddCentroCostoForm">
            <form action="">
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Centro de Costo</p>
                    </header>
                    <div class="modal-card-body">
                        <div class="nj-cols c2">
                            <div>
                                <div class="nj-label">Código</div>
                                <input type="text" class="nj-text" v-model="centrocosto.codigo">
                            </div>
                            <div>
                                <div class="nj-label">Descripción</div>
                                <input type="text" class="nj-text" v-model="centrocosto.descripcion">
                            </div>
                            <div>
                                <div class="nj-label">Proyecto</div>
                                <select class="nj-select" v-model="centrocosto.pry_id">
                                    <option></option>
                                    <option v-for="item in proyectos" :key="item.pry_id" :value="item.pry_id">{{ item.pry_nombre }}</option>
                                </select>
                            </div>
                            <div>
                                <div class="nj-label">Estado</div>
                                <b-checkbox v-model="centrocosto.es_activo">{{ centrocosto.es_activo ? "ACTIVO" : "INACTIVO" }}</b-checkbox>
                            </div>
                        </div>
                    </div>
                    <footer class="modal-card-foot">
                        <button class="button is-small" type="button" @click="cerrar()">Cerrar</button>
                        <button class="button is-primary is-small" @click.prevent="saveCentroCosto()">Guardar</button>
                    </footer>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios"
import { ProyectoService } from "../services"

export default {
    name: "CentroCostoList",
    data() {
        return {
            loading: false,
            data: [],
            perPage: 10,
            total: 0,
            page: 1,
            search: "",
            timer: null,
            centrocosto: {
                codigo: "",
                descripcion: "",
                pry_id: null,
                es_activo: true
            },
            proyectos: [],
            showBox: false
        }
    },
    methods: {
        deleteRow(row) {
            this.$buefy.dialog.confirm({
                message: "Esta seguro de eliminar el centro de costo",
                onConfirm: () => {
                    axios
                        .delete("/centroCosto/delete", {
                            data: { id_centro_costo: row.id_centro_costo }
                        })
                        .then(
                            () => {
                                this.$buefy.toast.open({
                                    message: `Se elimino el centro de costo ${row.codigo}`,
                                    type: "is-success"
                                })
                                this.loadDataTable()
                            },
                            err => {
                                this.$buefy.toast.open({
                                    message: `Ocurrio un problema al eliminar el centro de costo`,
                                    type: "is-danger"
                                })
                                console.error(err)
                            }
                        )
                }
            })
        },
        loadDataTable() {
            let _self = this
            _self.loading = true
            axios
                .post("/centroCosto/list", {
                    search: this.search,
                    length: this.perPage,
                    start: (this.page - 1) * this.perPage
                })
                .then(
                    response => {
                        _self.data = response.data.data
                        _self.total = response.data.total
                        _self.loading = false
                    },
                    err => {
                        _self.loading = false
                        console.error(err)
                    }
                )
        },
        onPageChange(page) {
            this.page = page
            this.loadDataTable()
        },
        searchData() {
            if (this.timer) {
                clearTimeout(this.timer)
                this.timer = null
            }
            let _self = this
            this.timer = setTimeout(() => _self.loadDataTable(), 1000)
        },
        saveCentroCosto() {
            let _self = this
            axios.post("/centroCosto/save", _self.centrocosto).then(
                response => {
                    this.$buefy.toast.open({
                        message: `Se agrego el centro de costo ${response.data.descripcion}`,
                        type: "is-success"
                    })
                    this.loadDataTable()
                    this.cleanAddCentroCostoForm()
                    _self.showBox = false
                },
                err => {
                    this.$buefy.toast.open({
                        message: err.response.data.message,
                        type: "is-danger"
                    })
                    this.cleanAddCentroCostoForm()
                    _self.showBox = false
                }
            )
        },
        cleanAddCentroCostoForm() {
            this.centrocosto = {
                codigo: "",
                descripcion: "",
                es_activo: true
            }
        },
        loadEditCentroCosto(row) {
            this.centrocosto = row
            this.showBox = true
        },
        cerrar() {
            this.showBox = false
            this.cleanAddCentroCostoForm()
        }
    },
    mounted() {
        // cargando los proyectos
        ProyectoService.buscar({
            pry_estado: 1
        }).then(
            response => {
                this.proyectos = response.data
                this.loadDataTable()
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
    }
}
</script>

<style scoped></style>
